import Udesk from 'Udesk';

export function trans(pamars, type) {
    localStorage.setItem(
        'maualAddToManage_pamars',
        JSON.stringify({
            judgeStrategy: 1,
            customJudgeLogic: '',
            keyword: '',
            keywordType: null,
            ...pamars,
        })
    );
    setTimeout(() => {
        if (type === Udesk.enums.inspectDataSources.voiceCall.id) {
            window.open('/site/call-manage/index');
        }
        if (type === Udesk.enums.inspectDataSources.textDialogue.id) {
            window.open('/site/dialogue-manage/index');
        }
        if (type === Udesk.enums.inspectDataSources.ticket.id) {
            window.open('/site/ticket-manage/index');
        }
        if (type === Udesk.enums.inspectDataSources.wechatDialogue.id) {
            window.open('/site/wechat-qa/chart-record/index');
        }
        if (type === Udesk.enums.inspectDataSources.taobao.id) {
            window.open('/site/e-commerce-manage/index');
        }
        if (type === Udesk.enums.inspectDataSources.videoCall.id) {
            window.open('/site/video-call-manage/index');
        }
        if (type === Udesk.enums.inspectDataSources.eComment.id) {
            window.open('/site/e-comment-manage/index');
        }
        if (type === Udesk.enums.inspectDataSources.mComment.id) {
            window.open('/site/m-comment-manage/index');
        }
        if (type === Udesk.enums.inspectDataSources.survey.id) {
            window.open('/site/survey-manage/index');
        }
        if (type === Udesk.enums.inspectDataSources.feishuGroup.id) {
            window.open('/site/feishu-qa/group-dialogue-manage/index');
        }
    });
}

export default {
    trans,
};
